interface MockCognitoUser {
  username: string;
  password: string;
  challengeName?: string;
}

export const setMockAuthUsers = (auth_users: MockCognitoUser[]) =>
  localStorage.setItem(
    'auth_users',
    JSON.stringify(
      auth_users.reduce<{ [key: string]: MockCognitoUser }>(
        (acc, curr) => ({
          ...acc,
          [curr.username]: {
            ...curr,
          },
        }),
        {}
      )
    )
  );
